module.exports = __webpack_public_path__ + "static/media/dog-nation.a01c1b7b.jpg";